// @flow

import * as React from 'react';
import { Environment } from '@ta/lithium.context';
import classNames from '@ta/common.classnames';

import styles from './DirectionalText.css';

type Props = {|
  contentLanguage?: string,
  truncate?: boolean,
  children: React.Node,
|};

type LanguageDirection = 'rtl' | 'ltr' | 'auto';

const languageDirection = (lang: ?string): LanguageDirection => {
  /**
   * Sometimes, we don't know the language of the text, so in this case we return direction auto
   * and the browser will take care of the alignment
   */
  if (!lang) {
    return 'auto';
  }
  if (lang.match(/^(ar|iw)/i)) {
    return 'rtl';
  }
  return 'ltr';
};

const DirectionalText = ({ children, contentLanguage, truncate }: Props) => {
  const direction = languageDirection(contentLanguage);
  const { isRtl } = React.useContext(Environment).locale;

  /*
   * If contentLanguage is passed and we are already in RTL and we don't need to truncate the text
   * we return the children without any element or class
   */
  if (direction !== 'auto' && !truncate && (direction === 'rtl') === isRtl) {
    return children;
  }

  return (
    <span
      className={classNames({
        [styles.truncate]: truncate,
      })}
      dir={direction}
    >
      {children}
    </span>
  );
};

export default DirectionalText;
